<template>
  <span class="p-input-icon-left min-w-min">
    <icon :icon="['far', 'search']" data-cy="search-icon" />
    <InputText
      v-model="searchText"
      type="search"
      placeholder="Search by Well or UWI..."
      class="w-full"
      data-cy="search-input"
    />
  </span>
</template>

<script setup lang="ts">
import { ref } from 'vue';
const props = defineProps<{
  advancedSearchItems: Record<string, any>;
  page: string;
  filterSizingsBool: boolean;
}>();

const searchText = ref('');

const { advancedSearchItems, page, filterSizingsBool } = props;
</script>